import { I18n } from '@calendly/i18n'

import { BaseNotificationSection } from '../base_notification_section'

export const EmailConfirmationSection = ({ eventType }) => (
  <BaseNotificationSection
    kind="invitee_confirmation"
    eventType={{ ...eventType, notification_type: 'email' }}
    skipDirtyCheck={eventType.notification_type !== 'email'}
    description={I18n.t('publisher.event_type_editor.sections.communications.invitation_confirmation.email_body')}
  />
)
